module.exports = __webpack_public_path__ + "static/la-ventures--ram-masinas-49a4485c57b0152c0a9b9807f7ea2968.mp4";